import React from 'react';

export default props => (
	<div className="HOME">
		<ul className="sets">
			{props.sets && props.sets.map(set => (
				<li key={set.id} onClick={() => props.handleSelectPanel('SET', { setId: set.id })}>
					<div className="name">{set.name}</div>

					<ul className="tallies">
						{set.tallies && set.tallies.map(tally => (
							<li key={tally.id}>
								<span className="count">{tally.marks ? tally.marks.length : '0'}</span>
								<span className="name">{tally.name}</span>
							</li>
						))}
					</ul>
				</li>
			))}
		</ul>
		
		<div className="primary-action">
			<button className="button alt-add-set" onClick={() => props.handleSelectModal('ADD-SET')}>Add Set</button>
		</div>

		<div className="user-status">
			<span>Logged In as {props.userEmail}</span>
			<button className="button" onClick={() => props.handleLogout()}>LOGOUT</button>
		</div>
	</div>
);


// WEBPACK FOOTER //
// ./src/components/home-panel.js